import { Outlet, useParams, Navigate } from 'react-router-dom';
import { LanguageProvider } from '@/contexts/LanguageContext';
import type { Lang } from '@/contexts/LanguageContext';
import GoldPriceTicker from './GoldPriceTicker';
import Header from './Header';
import Footer from './Footer';

const validLangs: Lang[] = ['en', 'ar', 'fr'];

const Layout = () => {
  const { lang } = useParams<{ lang: string }>();

  if (!lang || !validLangs.includes(lang as Lang)) {
    return <Navigate to="/ar" replace />;
  }

  return (
    <LanguageProvider lang={lang as Lang}>
      <div className="min-h-screen flex flex-col">
        <GoldPriceTicker />
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
};

export default Layout;
